import { useEffect, useState } from "preact/hooks";

export const useRefSize = (ref, deps) => {
  const [size, setSize] = useState<{ width?: number; height?: number }>({});
  useEffect(() => {
    let listener;
    console.log(ref, "REF");
    if (ref.current) {
      listener = () => {
        console.log(ref.current.getBoundingClientRect(), "resize");
        setSize(ref.current.getBoundingClientRect());
      };
      listener();
      window.addEventListener("resize", listener);
    }
    return window.removeEventListener("resize", listener);
  }, [ref, ...deps]);
  return size;
};
